<template>
  <div class="container" style="font-size: 13px">
    <div class="row mt-2">
      <div class="col-4">
        <input
          placeholder="Tgl. Online"
          class="form-control m-2"
          :type="typeTglOnline"
          @focus="typeTglOnline = 'date'"
          @blur="filter > tglonline == '' ? (typeTglOnline = 'text') : (typeTglOnline = 'date')"
          id="date"
          v-model="filter.tglonline"
        />
      </div>
      <div class="col-4">
        <input
          class="form-control m-2"
          type="number"
          placeholder="Tahun Online"
          id="tahun_online"
          v-model="filter.tahunonline"
        />
      </div>
      <div class="col-4">
        <input
          placeholder="Batch"
          class="form-control m-2"
          type="text"
          list="batch"
          v-model="filter.batch"
          @keyup="getDataBatch($event)"
        />
        <datalist id="batch">
          <option v-for="(batch, index) in dataBatch" :key="index">
            {{ batch.batch_komifo_batch }}
          </option>
        </datalist>
      </div>
      <div class="col-4">
        <input
          placeholder="Station"
          class="form-control m-2"
          type="text"
          list="station"
          v-model="filter.station"
          @keyup="getDataStation($event)"
        />
        <datalist id="station">
          <option v-for="(station, index) in dataStation" :key="index">
            {{ station.data }}
          </option>
        </datalist>
      </div>
      <div class="col-4">
        <select
          class="form-select m-2"
          v-model="filter.client"
          :class="filter.client ? '' : 'text-secondary'"
        >
          <option value="" selected>
            {{ filter.client ? "none" : "Client" }}
          </option>
          <option
            v-for="client in dataClient.content"
            :key="client.id"
            class="text-dark"
            :value="client.id"
          >
            {{ client.name }}
          </option>
        </select>
      </div>
      <div class="col-4">
        <input
          placeholder="QR Code"
          class="form-control m-2"
          type="text"
          list="qrcode"
          v-model="filter.qrcode"
          @keyup="getDataQR($event)"
        />
        <datalist id="qrcode">
          <option v-for="(station, index) in dataQr" :key="index">
            {{ station.data }}
          </option>
        </datalist>
      </div>
      <div class="col-4">
        <input
          placeholder="Mulai Tgl. Registrasi"
          class="form-control m-2"
          :type="typeRegisStart"
          @focus="typeRegisStart = 'date'"
          @blur="filter.startreg == '' ? (typeRegisStart = 'text') : (typeRegisStart = 'date')"
          id="date"
          v-model="filter.startreg"
        />
      </div>
      <div class="col-4">
        <input
          placeholder="Akhir Tgl. Registrasi"
          class="form-control m-2"
          :type="typeRegisEnd"
          @focus="typeRegisEnd = 'date'"
          @blur="filter.endreg == '' ? (typeRegisEnd = 'text') : (typeRegisEnd = 'date')"
          id="date"
          v-model="filter.endreg"
        />
      </div>
      <div class="col-4">
        <button
          @click="getDataKominfo(0)"
          class="btn btn-success rounded-pill shadow text-white mx-2"
        >
          <i class="fa fa-search"></i>
        </button>
        <button
          @click="refreshFilter()"
          class="btn btn-success rounded-pill shadow text-white mx-2"
        >
          <i class="fa fa-refresh"></i>
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-header p-4 pb-0">
            <div class="row">
              <div class="col-6">
                <b>Perangkat</b>
              </div>
              <div class="col-6">
                <div class="float-end" v-if="!filterNull">
                  <button
                    class="btn btn-sm mx-1 px-4"
                    @click="exportxls()"
                    data-bs-toggle="modal"
                    data-bs-target="#modalLoading"
                  >
                    <i class="fa fa-file-excel-o text-success"></i> &nbsp; .xls
                  </button>
                  <button
                    class="btn btn-sm mx-1 px-4"
                    @click="exportSertif()"
                    data-bs-toggle="modal"
                    data-bs-target="#modalLoading"
                  >
                    <i class="fa fa-print text-primary"></i>
                    &nbsp; sertifikat
                  </button>
                </div>
                <div class="float-end" v-else>
                  <button class="btn btn-sm mx-1 px-4" @click="store.dispatch('swalErrorDownload')">
                    <i class="fa fa-file-excel-o text-success"></i> &nbsp; .xls
                  </button>
                  <button class="btn btn-sm mx-1 px-4" @click="store.dispatch('swalErrorDownload')">
                    <i class="fa fa-print text-primary"></i>
                    &nbsp; sertifikat
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body py-1 px-3">
            <table-postel
              :data-length="dataLength"
              :data-postel="dataTablePostel"
              :offset="pageOffset"
              :page-length="pageLength"
              :current-page="currentpage"
              :size="eachPageSize"
            >
              <template #button>
                <paginate
                  v-model="pagination"
                  :page-count="pageLength"
                  :page-range="5"
                  :margin-pages="1"
                  :click-handler="movePage"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                  :first-last-button="true"
                  first-button-text="<<"
                  last-button-text=">>"
                >
                </paginate>
              </template>
            </table-postel>
          </div>
        </div>
      </div>
    </div>
    <modal modalName="modalLoading" :isFooter="false" :isHeader="false">
      <template #body>
        <div class="text-center">
          <span>
            <h2 class="fs-5">
              {{ store.state.isLoadingDownload ? "Loading Process" : "done !" }}
            </h2>
            <argon-progress :percentage="percentage" variant="gradient" color="success" />
            <p v-show="!processFailed" class="fs-5">{{ percentage }}%</p>
            <p v-show="processFailed" class="fs-5 text-danger">Proses Gagal !</p>
            <button
              v-show="!store.state.isLoadingDownload"
              class="btn btn-outline-success mt-4 me-2"
              data-bs-dismiss="modal"
              @click="processFailed = false"
            >
              Ok
            </button>
            <button
              v-show="!store.state.isLoadingDownload && processFailed === true"
              class="btn btn-success mt-4"
              @click="(processFailed = false), tryAgain()"
            >
              Coba Lagi!
            </button>
          </span>
        </div>
      </template>
    </modal>
  </div>
</template>

<script setup>
//Import
import ArgonProgress from "@/components/ArgonProgress.vue";
import Modal from "@/components/ModalComponent.vue";
import TablePostel from "../../components/perangkat/TablePostel.vue";
import Paginate from "vuejs-paginate-next";

import { ref } from "@vue/reactivity";
import { computed, onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import { ApiService } from "@/axios/apiService";

//data
const pagination = computed(() => currentpage.value + 1);
const apiService = new ApiService();
const store = useStore();
let dataTablePostel = ref();
let pageLength = ref(0);
let dataLength = ref(0);
const pageOffset = computed(() => {
  if (dataLength.value < 1) {
    return 0;
  }
  return 10 * currentpage.value + 1;
});
let eachPageSize = ref(0);
const filter = ref({
  tglonline: "",
  tahunonline: "",
  batch: "",
  station: "",
  idreg: "",
  qrcode: "",
  startreg: "",
  endreg: "",
  client: "",
});
const dataClient = ref([]);
const currentpage = ref(0);
const dataQr = ref([]);
const dataBatch = ref([]);
const dataStation = ref([]);
const percentage = ref(0);
const processFailed = ref(false);
const typeTglOnline = ref("text");
const typeRegisEnd = ref("text");
const typeRegisStart = ref("text");
let iDownload = 0;
let tryAgain_ = 0;

//methods
const exportSertif = async () => {
  try {
    const data = filter.value;
    store.state.isLoadingDownload = true;
    const batch = data.batch ? data.batch : "no_batch";

    let params = "";
    if (data.tglonline !== "" && data.tglonline !== null) {
      params += `&tglonline=${data.tglonline}`;
    }
    if (data.tahunonline !== "" && data.tahunonline !== null) {
      params += `&tahunonline=${data.tahunonline}`;
    }
    if (data.batch !== "" && data.batch !== null) {
      params += `&batch=${data.batch}`;
    }
    if (data.client !== "" && data.client !== null) {
      params += `&client=${data.client}`;
    }
    if (data.qrcode !== "" && data.qrcode !== null) {
      params += `&qrcode=${data.qrcode}`;
    }
    if (data.startreg !== "" && data.startreg !== null) {
      params += `&startDate=${data.startreg}`;
    }
    if (data.endreg !== "" && data.endreg !== null) {
      params += `&endDate=${data.endreg}`;
    }
    if (data.station !== "" && data.station !== null) {
      params += `&station=${data.station}`;
    }

    const sizeContent = 100;
    const len = Math.ceil(dataLength.value / sizeContent);

    for (let index = 0; index < len; index++) {
      let pagenow = index + 1;
      percentage.value = Math.round((pagenow / len) * 100);
      const response = await apiService.downloadSertifikat(sizeContent, iDownload, params);
      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = href;
      const filename = `Sertificate-batch-${batch}-${iDownload}.zip`;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      iDownload++;
    }
    iDownload = 0;
    store.state.isLoadingDownload = false;
  } catch (error) {
    tryAgain_ = 1;
    console.log(error);
    processFailed.value = true;
    store.state.isLoadingDownload = false;
  }
};

const exportxls = async () => {
  try {
    const data = filter.value;
    store.state.isLoadingDownload = true;
    let params = "";
    if (data.tglonline !== "" && data.tglonline !== null) {
      params += `&tglOnline=${data.tglonline}`;
    }
    if (data.tahunonline !== "" && data.tahunonline !== null) {
      params += `&tahunOnline=${data.tahunonline}`;
    }
    if (data.batch !== "" && data.batch !== null) {
      params += `&batch=${data.batch}`;
    }
    if (data.client !== "" && data.client !== null) {
      params += `&client=${data.client}`;
    }
    if (data.qrcode !== "" && data.qrcode !== null) {
      params += `&siteCode=${data.qrcode}`;
    }
    if (data.startreg !== "" && data.startreg !== null) {
      params += `&startDate=${data.startreg}`;
    }
    if (data.endreg !== "" && data.endreg !== null) {
      params += `&endDate=${data.endreg}`;
    }
    if (data.station !== "" && data.station !== null) {
      params += `&earthStationName=${data.station}`;
    }
    percentage.value = 80;
    const response = await apiService.downloadExcelPostel(params);
    const href = URL.createObjectURL(response.data);
    let link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "PERANGKAT-KOMINFO-" + dataLength.value + ".xlsx"); //or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
    percentage.value = 100;
    store.state.isLoadingDownload = false;
  } catch (error) {
    tryAgain_ = 2;
    console.log(error);
    processFailed.value = true;
    store.state.isLoadingDownload = false;
  }
};

const filterNull = computed(() => {
  const data = filter.value;
  if (
    data.tglonline === "" &&
    data.tahunonline === "" &&
    data.batch === "" &&
    data.station === "" &&
    data.idreg === "" &&
    data.qrcode === "" &&
    data.startreg === "" &&
    data.endreg === "" &&
    data.client === ""
  ) {
    return true;
  } else {
    return false;
  }
});

const tryAgain = async () => {
  if (tryAgain_ === 1) {
    await exportSertif();
  } else if (tryAgain_ === 2) {
    await exportxls();
  }
};

const refreshFilter = async () => {
  filter.value = {
    tglonline: "",
    tahunonline: "",
    batch: "",
    station: "",
    idreg: "",
    qrcode: "",
    startreg: "",
    endreg: "",
    client: "",
  };
  typeRegisEnd.value = "text";
  typeRegisStart.value = "text";
  typeTglOnline.value = "text";
  await getDataKominfo(0);
};

const getDataPelanggan = async () => {
  const res = await apiService.getPelanggan(10, 0);
  dataClient.value = res.data;
};

const getDataKominfo = async (pageNumber) => {
  currentpage.value = pageNumber;
  const data = filter.value;
  try {
    store.state.isLoading = true;
    const params = `&earthStationName=${data.station}&noRegistrasi=${data.idreg}&siteCode=${data.qrcode}&batch=${data.batch}&tahunOnline=${data.tahunonline}&tglOnline=${data.tglonline}&startDate=${data.startreg}&endDate=${data.endreg}&client=${data.client}`;
    filterMove = params;
    const res = await apiService.getAllPerangkatPostel(10, pageNumber, params);
    dataTablePostel.value = res.data.content;
    pageLength.value = res.data.totalPages;
    dataLength.value = res.data.totalElements;
    pageOffset.value = res.data.pageable.offset;
    eachPageSize.value = res.data.size;
    store.state.selectedPostelStations = [];
    store.state.isLoading = false;
  } catch (error) {
    console.log(error);
    store.state.isLoading = false;
  }
};

let filterMove = "";
const movePage = async (pageNumber) => {
  store.state.isLoading = true;
  currentpage.value = pageNumber - 1;
  const res = await apiService.getAllPerangkatPostel(10, currentpage.value, filterMove);
  dataTablePostel.value = res.data.content;
  pageLength.value = res.data.totalPages;
  dataLength.value = res.data.totalElements;
  pageOffset.value = res.data.pageable.offset;
  eachPageSize.value = res.data.size;
  store.state.isLoading = false;
};

let timeoutIdBatch;
const getDataBatch = async (e) => {
  try {
    if (timeoutIdBatch) {
      clearTimeout(timeoutIdBatch);
    }
    const data = filter.value.batch;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdBatch = setTimeout(async () => {
        const res = await apiService.getBatchPostel(data);
        dataBatch.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

let timeoutIdStation;
const getDataStation = async (e) => {
  try {
    if (timeoutIdStation) {
      clearTimeout(timeoutIdStation);
    }
    const data = filter.value.station;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdStation = setTimeout(async () => {
        const res = await apiService.getStation(data);
        dataStation.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

let timeoutIdQR;
const getDataQR = async (e) => {
  try {
    if (timeoutIdQR) {
      clearTimeout(timeoutIdQR);
    }
    const data = filter.value.qrcode;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdQR = setTimeout(async () => {
        const res = await apiService.getQrCodePostel(data);
        dataQr.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  await getDataKominfo(currentpage.value);
  await getDataPelanggan();
});
</script>
